var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinEventLtr = function SvgPinEventLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.674 21.954-2.856 3.955h-5.272l-2.856-3.955z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M50 0c18.225 0 33 14.905 33 33.29 0 5.503-1.327 10.82-3.83 15.578-1.55 2.952-4.696 8.818-9.06 16.912l-8.737 16.172-9.056 16.713c-1.052 1.807-3.677 1.779-4.68-.082L20.854 48.914A33.4 33.4 0 0 1 17 33.29C17 14.904 31.775 0 50 0M30 18l11.204 15.653v9.393H37.91V47h10.545v-3.954H45.16v-9.338L56.363 18zm30.318 0v16.367a3.6 3.6 0 0 0-1.253-.446 9 9 0 0 0-1.383-.103q-2.746 0-4.668 1.922t-1.923 4.67q0 2.746 1.923 4.668Q54.935 47 57.682 47t4.669-1.922 1.921-4.669V23.273h5.274V18z",
    clipRule: "evenodd"
  })));
};
export default SvgPinEventLtr;